import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Globe, Users, PawPrint, ArrowRight } from 'lucide-react';
import FeaturedSuggestion from '../components/FeaturedSuggestion';

const WorldPetsLanding = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Hero Section */}
      <div className="max-w-4xl mx-auto px-4 py-20 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center">
            <Globe className="w-10 h-10 text-white" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Welcome to <span className="text-blue-600">WorldPets</span>
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          A global network of pet clubs, communities, and services. 
          Find your local club or discover pet communities around the world.
        </p>

        <Link to="/clubs">
          <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg">
            Browse Clubs
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </Link>
      </div>

      {/* Features Preview */}
      <div className="max-w-5xl mx-auto px-4 pb-20">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <PawPrint className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Pet Clubs</h3>
            <p className="text-gray-600">
              Join breed-specific clubs, regional communities, and special interest groups.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <Users className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Community</h3>
            <p className="text-gray-600">
              Connect with pet owners, share experiences, and learn from experts.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <Globe className="w-6 h-6 text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Global Network</h3>
            <p className="text-gray-600">
              Access resources and communities from pet clubs worldwide.
            </p>
          </div>
        </div>
      </div>

      {/* Featured Suggestion */}
      <div className="max-w-3xl mx-auto px-4 py-6">
        <FeaturedSuggestion />
      </div>

      {/* Footer CTA */}
      <div className="bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-gray-600 mb-4">
            Looking for a specific club?
          </p>
          <Link to="/clubs" className="text-blue-600 hover:text-blue-700 font-medium">
            View all clubs →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WorldPetsLanding;
